import script from "./TariffPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TariffPage.vue?vue&type=script&lang=ts&setup=true"

import "./TariffPage.vue?vue&type=style&index=0&id=aa4c4ad0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa4c4ad0"]])

export default __exports__